<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

import { PropertyOnboardingType } from '@tallo/investor/navigation';
import { usePropertyStore } from '@tallo/investor/property';

const propertyStore = usePropertyStore();
const route = useRoute();
const propertyId = route.params.propertyId;

if (propertyId.toString() !== PropertyOnboardingType.NewProperty) {
  propertyStore.loadProperty(propertyId.toString());
}

onUnmounted(() => {
  propertyStore.$reset();
});
</script>

<style scoped lang="scss"></style>
